import moment from 'moment'

const AFTERPAY = 'Afterpay'

export const storeAcceptsGiftCard = paymentMethods =>
  paymentMethods && paymentMethods.includes('Westfield Giftcard')

export const storeAcceptsAfterPay = paymentMethods =>
  paymentMethods && paymentMethods.includes(AFTERPAY)

export const storeIsOpen = status => status && status.toLowerCase() === 'open'

export const storeIsOpeningSoon = status =>
  status && status.toLowerCase() === 'opening soon'

export const isAfterDate = (date, comparator = moment()) =>
  moment(date).isSameOrBefore(comparator)
